/****************************************
Component for Redux Form that searchs for accounts by name, email, or reference code.
****************************************/

import React, { Component } from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import axios from 'axios';
import _ from 'lodash';

export class ReferenceField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFetching: false,
			loading: false,
			searchQuery: null,
			options: [],
			searchType: 'email',
			open: false,
		};

		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSearchTypeChange = this.handleSearchTypeChange.bind(this);
	}

	handleChange(e, { value })  {
		this.props.input.onChange(value);
	}

	async handleSearchChange (e, { searchQuery }) {
		if(searchQuery !== '')
		{
			const response = await axios.post('/api/search/reference', { search: searchQuery });

			const d = response.data.map((obj) => {
				return({key: obj._id, text: `${_.capitalize(obj.firstname)} ${_.capitalize(obj.lastname)} - ${obj.email}`, value: obj._id});
			});

			await this.setState({options: d});
		}
		else {
			this.props.input.onChange(null);
			await this.setState({options: []});
		}

	}

	handleSearchTypeChange(e, { value }) {
		this.setState({ searchType: value });
	}

	render() {
		const { label, required, meta: { touched, error } } = this.props;

		return(
			<Form.Field required={required} error={touched && !!error}>
				<label>{label}</label>
				<Dropdown
					fluid
					selection
					search
					options={this.state.options}
					value={this.props.input.value}
					placeholder='Search by name, email or reference code'
					onChange={this.handleChange}
					onSearchChange={this.handleSearchChange}
					disabled={this.state.isFetching}
					loading={this.state.isFetching}
				/>
				<p>{touched && error}</p>
			</Form.Field>
		);
	}
}

export const ReferenceFieldAsyncValidate = async (values, dispatch, props, field) => {
	if(field === 'reference') {
		return axios.post('/api/check/referencefield', { reference: values.reference })
			.then((res) => {
				if(res.data.exists === false) {
					const previousErrors = props.asyncErrors;
					throw Object.assign({}, previousErrors, {reference: 'We can\'t find that representative.'});
				}
			});
	}
};
